enum InterestSpecificDataOptions {
  LESS_THAN_A_MONTH = "LESS_THAN_A_MONTH",
  ONE_TO_THREE_MONTHS = "ONE_TO_THREE_MONTHS",
  THREE_TO_SIX_MONTHS = "THREE_TO_SIX_MONTHS",
  SIX_TO_TWELVE_MONTHS = "SIX_TO_TWELVE_MONTHS",
  MORE_THAN_A_YEAR = "MORE_THAN_A_YEAR"
}

export { InterestSpecificDataOptions }
